import { render, staticRenderFns } from "./conferenceDetail.vue?vue&type=template&id=0bdc201d&"
import script from "./conferenceDetail.vue?vue&type=script&lang=js&"
export * from "./conferenceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports